import { useThrottledToast } from '../../hooks/useThrottledToast';

import { Switch, PageHeader, Heading } from '../../shared/ui';
// import { YandexPlayerHandle } from '../../components/tools/dpdg/YandexVideo';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { useChangeUserMutation } from '../../services/users.api';
import { selectUser, setUserData } from '../../store/auth.slice';
import { useTariffToolCheck } from '../../hooks/useTariffToolCheck';

const Dpdg = () => {
  const tool = 'dpdg';
  const dispatch = useAppDispatch();
  const userData = useAppSelector(selectUser);

  const [changeUser] = useChangeUserMutation();
  const showToast = useThrottledToast();
  // const yandexPlayerRef = useRef<YandexPlayerHandle>(null);

  const isActiveByTariff = useTariffToolCheck(tool);

  const handleCheck = async () => {
    try {
      if (!isActiveByTariff) return;
      if (!userData) return;
      if (userData?.active_psy_tools?.includes(tool)) {
        const arr = userData?.active_psy_tools.filter((el) => el !== tool);
        dispatch(setUserData({ ...userData, active_psy_tools: arr }));
        await changeUser({
          id: userData.id,
          active_psy_tools: arr,
        });
      } else {
        dispatch(
          setUserData({
            ...userData,
            active_psy_tools: [...userData?.active_psy_tools, tool],
          }),
        );
        await changeUser({
          id: userData.id,
          active_psy_tools: [...userData?.active_psy_tools, tool],
        });
      }
      showToast('success');
    } catch (error) {
      showToast('error');
    }
  };

  return (
    <div className="pb-[80px]">
      <PageHeader backTo="/tools" title="ДПДГ онлайн" />
      <div className="space-y-6 text-ui text-ink-muted leading-relaxed mb-8">
        <section>
          <Heading size="sm" className="mb-2">
            Цель и назначение
          </Heading>
          <p>
            «ДПДГ онлайн» — цифровая реализация протокола десенсибилизации и переработки движениями глаз. Инструмент
            встроен в комнату ZiNGiZi и позволяет сертифицированным специалистам проводить сессии по работе с ПТСР,
            тревогой и интенсивными эмоциональными переживаниями.
          </p>
        </section>
        <div className="flex items-center gap-5 mb-[40px]">
          <Switch
            checked={userData?.active_psy_tools?.includes(tool)}
            disabled={!isActiveByTariff}
            onChange={() => handleCheck()}
            label={'Использовать ДПДГ в видео-сессиях'}
          />
        </div>
        <section>
          <Heading size="sm" className="mb-2">
            Как работает модуль
          </Heading>
          <ol className="list-decimal pl-5 space-y-2 mt-2">
            <li>
              Психолог активирует инструмент и выбирает траекторию движения (горизонт, вертикаль, диагональ или круг).
            </li>
            <li>Клиент переводит устройство в требуемую ориентацию и следит за движущимся объектом на экране.</li>
            <li>
              Во время стимуляции психолог задаёт вопросы, отслеживает субъективный уровень напряжения и при
              необходимости ставит видео на паузу.
            </li>
            <li>После завершения серии фиксируется изменение ощущений.</li>
          </ol>
        </section>

        <section>
          <Heading size="sm" className="mb-2">
            Встроенные возможности
          </Heading>
          <ul className="list-disc pl-5 space-y-2">
            <li>Гибкая настройка траектории, скорости и размера визуального стимула.</li>
            <li>Интеграция с видеосессией без переключения вкладок и сторонних приложений.</li>
          </ul>
        </section>

        <section>
          <Heading size="sm" className="mb-2">
            Клиническая эффективность
          </Heading>
          <p>
            Метод ДПДГ подтверждён исследованиями и признан профессиональными ассоциациями мира. Онлайн-модуль сохраняет
            структуру протокола, добавляя цифровой комфорт и контроль, что позволяет безопасно использовать технику в
            рамках онлайн-психотерапии.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Dpdg;
